let ctx: AudioContext | null = null;
let enabled = true;
let masterVolume = parseFloat(localStorage.getItem('ace_volume') || '0.7');

const getCtx = (): AudioContext => {
  if (!ctx) ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});
  return ctx;
};

const initOnGesture = () => {
  getCtx();
  document.removeEventListener('click', initOnGesture, true);
  document.removeEventListener('touchstart', initOnGesture, true);
};
document.addEventListener('click', initOnGesture, true);
document.addEventListener('touchstart', initOnGesture, true);

export const setSoundEnabled = (on: boolean) => { enabled = on; };
export const isSoundEnabled = () => enabled;

export const setVolume = (v: number) => {
  masterVolume = Math.max(0, Math.min(1, v));
  localStorage.setItem('ace_volume', String(masterVolume));
};
export const getVolume = () => masterVolume;

function tone(freq: number, dur: number, type: OscillatorType = 'sine', vol = 0.3) {
  if (!enabled) return;
  const scaledVol = vol * masterVolume;
  if (scaledVol < 0.001) return;
  try {
    const c = getCtx();
    const o = c.createOscillator();
    const g = c.createGain();
    o.connect(g);
    g.connect(c.destination);
    o.frequency.value = freq;
    o.type = type;
    g.gain.setValueAtTime(scaledVol, c.currentTime);
    g.gain.exponentialRampToValueAtTime(0.001, c.currentTime + dur);
    o.start();
    o.stop(c.currentTime + dur);
  } catch { /* audio unavailable */ }
}

const noiseCache = new Map<number, AudioBuffer>();

function getNoiseBuffer(c: AudioContext, dur: number): AudioBuffer {
  const len = Math.round(c.sampleRate * dur);
  const cached = noiseCache.get(len);
  // Validate cached buffer belongs to the same sample rate
  if (cached && cached.sampleRate === c.sampleRate) return cached;
  const buf = c.createBuffer(1, len, c.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
  noiseCache.set(len, buf);
  return buf;
}

function noise(dur: number, vol = 0.1) {
  if (!enabled) return;
  const scaledVol = vol * masterVolume;
  if (scaledVol < 0.001) return;
  try {
    const c = getCtx();
    const src = c.createBufferSource();
    const g = c.createGain();
    src.buffer = getNoiseBuffer(c, dur);
    src.connect(g);
    g.connect(c.destination);
    g.gain.setValueAtTime(scaledVol, c.currentTime);
    g.gain.exponentialRampToValueAtTime(0.001, c.currentTime + dur);
    src.start();
  } catch { /* audio unavailable */ }
}

export const Sounds = {
  cardPlay: () => {
    noise(0.06, 0.15);
    tone(800, 0.06, 'square', 0.05);
  },

  cut: () => {
    tone(300, 0.15, 'sawtooth', 0.2);
    setTimeout(() => tone(200, 0.3, 'sawtooth', 0.2), 100);
    setTimeout(() => tone(150, 0.4, 'sawtooth', 0.15), 250);
  },

  yourTurn: () => {
    tone(523, 0.1, 'sine', 0.15);
    setTimeout(() => tone(659, 0.1, 'sine', 0.15), 100);
    setTimeout(() => tone(784, 0.12, 'sine', 0.18), 200);
  },

  timerTick: () => {
    tone(1000, 0.04, 'square', 0.06);
  },

  timerUrgent: () => {
    tone(880, 0.08, 'square', 0.1);
    setTimeout(() => tone(880, 0.08, 'square', 0.1), 100);
  },

  playerSafe: () => {
    tone(660, 0.08, 'sine', 0.12);
    setTimeout(() => tone(880, 0.12, 'sine', 0.12), 80);
  },

  gameOverWin: () => {
    [523, 659, 784, 1047].forEach((f, i) =>
      setTimeout(() => tone(f, 0.2, 'sine', 0.18), i * 120)
    );
  },

  gameOverLose: () => {
    [392, 349, 311, 262].forEach((f, i) =>
      setTimeout(() => tone(f, 0.3, 'sawtooth', 0.08), i * 200)
    );
  },

  borrowIncoming: () => {
    tone(440, 0.12, 'sine', 0.12);
    setTimeout(() => tone(554, 0.12, 'sine', 0.12), 120);
  },

  dealCard: () => {
    noise(0.03, 0.08);
  },

  shuffle: () => {
    for (let i = 0; i < 6; i++) setTimeout(() => noise(0.04, 0.1), i * 50);
  },
};
